import { v4 as UUID } from "uuid";

interface SkeletonLoaderProps {
  rows: number;
}

export const SkeletonLoader = ({ rows }: SkeletonLoaderProps) => (
  <div className="bg-primary border-primary mt-4 rounded-md border p-2">
    <ul className="list-none">
      {[...Array(rows)].map(() => (
        <div
          key={UUID()}
          className="bg-tertiary mt-2 h-6 w-full animate-pulse rounded-md"
        />
      ))}
    </ul>
  </div>
);
